import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import AccessTimeIcon from '@mui/icons-material/AccessTime';

import SearchBarSingle from '../../../components/SearchBarV3/SearchBarSingle';
import { BLACK } from '../../../theme/colorConstants';
import { getAllValidShiftTimes } from '../../jobOrdersCreate/helpers';

import { textFieldSx } from './formFieldStyles';

const TimeField = ({ value, onChange, onBlur, error = false, ariaLabel, testId }) => {
  const options = useMemo(() => getAllValidShiftTimes(), []);
  const optionValue = useMemo(
    () => options.find((option) => option.value === value) || null,
    [options, value]
  );

  const handleChange = (nextOption) => {
    if (Number.isFinite(nextOption?.value)) {
      onChange(nextOption.value);
    }
  };

  const handleBlurCapture = (event) => {
    if (!onBlur) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      onBlur();
    }
  };

  return (
    <div onBlurCapture={handleBlurCapture}>
      <SearchBarSingle
        testId={testId}
        dropDownOptions={options}
        optionDisplayField="displayLabel"
        placeholder={ariaLabel}
        sx={{ ...textFieldSx, minWidth: '150px' }}
        EndIcon={AccessTimeIcon}
        customIconColor={BLACK[80]}
        input={{
          value: optionValue,
          onChange: handleChange,
        }}
        meta={{
          submitFailed: false,
          error: null,
          modified: false,
          touched: false,
        }}
        shouldErrorColor={error}
        fullWidth
      />
    </div>
  );
};

TimeField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  ariaLabel: PropTypes.string,
  testId: PropTypes.string,
};

export default TimeField;
